<div class="ion-text-center grey">
  <ion-icon name="refresh-outline" class="big"></ion-icon>
  <p>
    <ion-icon name="arrow-down-outline"></ion-icon>
    Tirar para actualizar
  </p>
</div>
